import { useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import api from "@/lib/api";
import { isNativeApp } from "@/lib/native";

// Registers this phone for trade-signal push notifications (native apps only).
export default function PushRegistrar() {
  useEffect(() => {
    if (!isNativeApp()) return undefined;
    const subs = [];
    (async () => {
      try {
        let perm = await PushNotifications.checkPermissions();
        if (perm.receive === "prompt") perm = await PushNotifications.requestPermissions();
        if (perm.receive !== "granted") return;
        subs.push(await PushNotifications.addListener("registration", (t) => {
          api.post("/push/register", { token: t.value, platform: Capacitor.getPlatform() }).catch(() => {});
        }));
        subs.push(await PushNotifications.addListener("registrationError", () => {}));
        await PushNotifications.register();
      } catch { /* push is optional */ }
    })();
    return () => { subs.forEach((s) => s.remove && s.remove()); };
  }, []);
  return null;
}
